import { JSX, useState } from "react";
import { get_token, get_token_agricultor } from "../Hook/useApi";
import { User } from "../Types/User";
import { AuthContext } from "./AuthContext";
import { jwtDecode } from "jwt-decode";
import { verify_role } from "./../Func_genericas/verify_role";
import { func_print } from "../Func_genericas/func_print";
import { useCookies } from "react-cookie";
import { IGrupos_Homo_Eficiencia_Alimentar } from "../Interfaces/eficiencia_alimentar/plano_de_alimentacao";

let logoutRef = () => { };

export const AuthProvider = ({ children }: { children: JSX.Element }) => {
  const [user, setUser] = useState<User | null>(null);
  const [user_role, set_user_role] = useState<string | null>(null);
  const [id_agricultor_externo, set_id_agricultor_externo] = useState<number | null>(null);
  const [nif_agricultor_from_caderno, setNif_agricultor_from_caderno] = useState<string | null>(null);
  const [nome_agricultor_from_caderno, setNome_agricultor_from_caderno] = useState<string | null>(null);
  const [id_rosto_from_caderno, setid_rosto_from_caderno] = useState<number | null>(null);
  const [idagri, setidagri] = useState<number | null>(null);
  const [id_identificacao_from_eficiencia, set_id_identificacao_from_eficiencia] = useState<number | null>(null);
  const [id_registo_caderno_eficiencia, set_id_registo_caderno_eficiencia] = useState<number | null>(null);
  const [lista_grupos_homo_eficiencia, set_lista_grupos_homo_eficiencia] = useState<IGrupos_Homo_Eficiencia_Alimentar[]>([]);
  const [refresh_grupos_homo_eficiencia, set_refresh_grupos_homo_eficiencia] = useState<number>(0);
  const [cor, set_cor] = useState<string>('')
  const [cultura, set_cultura] = useState<string>('')
  const [is_historico, set_is_historico] = useState<any>({
    id: 0,
    is_historico: false
  })



  const [token, set_token, remove_token] = useCookies(['cookie_token']);


  const signin = async (dados: any) => {

    try {
      const data: any = await get_token(dados);


      if (data.flag === true) {

        setUser(data.token);
        set_token('cookie_token', data.data)
        set_user_role(verify_role(data.data, ''))
        const ext = data.token?.id_agricultor_externo;
        set_id_agricultor_externo(ext != null && ext !== '' ? Number(ext) : null);

        return {
          flag: true,
          error: "",
        };
      } else if (data.flag === false) {
        return { flag: false, error: data.data };
      } else {
        return { flag: false, error: data.data };
      }
    } catch (error) {
      func_print("signin", error, true);
      return { flag: false, error: error };
    }
  };


  const signin_agricultor = async (dados: any) => {

    try {
      const data: any = await get_token_agricultor(dados);

      if (data.flag === true) {

        setUser(data.token);
        set_token('cookie_token', data.data)

        set_user_role(verify_role(data.data, ''))
        const ext = data.token?.id_agricultor_externo;
        set_id_agricultor_externo(ext != null && ext !== '' ? Number(ext) : null);

        return {
          flag: true,
          error: "",
        };
      } else {
        const err = data.error ?? data.data;
        return {
          flag: false,
          error: typeof err === "string" ? err : err != null ? String(err) : "Erro ao iniciar sessão.",
        };
      }
    } catch (error) {
      func_print("signin_agricultor", error, true);
      return { flag: false, error: error };
    }
  };

  const signout = () => {
    setUser(null);
    remove_token('cookie_token')
    set_user_role(null)
    set_id_agricultor_externo(null)
  };

  logoutRef = signout;

  const func_set_user_role = (role: string) => {
    set_user_role(role);
  };
  const func_set_id_agricultor_externo = (id: number | null) => {
    set_id_agricultor_externo(id);
  };

  const func_set_user = (token_obj: any) => {
    const token: any = jwtDecode(token_obj);
    setUser(token);

    set_token('cookie_token', token_obj);
    const ext = token?.id_agricultor_externo;
    set_id_agricultor_externo(ext != null && ext !== '' ? Number(ext) : null);
  };
  const func_setNif_agricultor_from_caderno = (nif_agri: string) => {
    setNif_agricultor_from_caderno(nif_agri);
  };

  const func_setNome_agricultor_from_caderno = (nome_agri: string) => {
    setNome_agricultor_from_caderno(nome_agri);
  };

  const func_setId_rosto_from_caderno = (id_rosto: number) => {
    setid_rosto_from_caderno(id_rosto);
  };

  const func_set_id_agricultor_para_eficiencia_alimentar = (idagri: number) => {
    setidagri(idagri)
  }

  const func_set_id_identificacao_from_eficiencia = (id_identificacao: number) => {
    set_id_identificacao_from_eficiencia(id_identificacao)
  }

  const func_set_id_registo_caderno_eficiencia = (id_registo_caderno_eficiencia: number) => {
    set_id_registo_caderno_eficiencia(id_registo_caderno_eficiencia)
  }

  const func_set_lista_grupos_homo_eficiencia = (lista_grupo_homo: IGrupos_Homo_Eficiencia_Alimentar[]) => {
    set_lista_grupos_homo_eficiencia(lista_grupo_homo);
    set_refresh_grupos_homo_eficiencia(refresh_grupos_homo_eficiencia + 1)
  }
  const func_set_cor = (cor: string) => {
    set_cor(cor)
  }

  const func_set_cultura = (cultura: string) => {
    set_cultura(cultura)
  }

  const func_set_is_historico = (is_historico: any) => {
    set_is_historico(is_historico)
  }
  return (
    <AuthContext.Provider
      value={{
        user_role,
        user,
        id_agricultor_externo,
        nif_agricultor_from_caderno,
        nome_agricultor_from_caderno,
        id_rosto_from_caderno,
        idagri,
        id_identificacao_from_eficiencia,
        id_registo_caderno_eficiencia,
        lista_grupos_homo_eficiencia,
        refresh_grupos_homo_eficiencia,
        token,
        cor,
        cultura,
        is_historico,
        func_set_user,
        func_set_user_role,
        func_set_id_agricultor_externo,
        func_setNif_agricultor_from_caderno,
        func_setNome_agricultor_from_caderno,
        func_setId_rosto_from_caderno,
        func_set_id_agricultor_para_eficiencia_alimentar,
        func_set_id_identificacao_from_eficiencia,
        func_set_id_registo_caderno_eficiencia,
        func_set_lista_grupos_homo_eficiencia,
        signin,
        signin_agricultor,
        signout,
        func_set_cor,
        func_set_cultura,
        func_set_is_historico,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
export const logoutApp = () => logoutRef();